module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/41880799fe091bc1302b42c64710352a.svg";